import { render, staticRenderFns } from "./EmployeePayroll.vue?vue&type=template&id=e2fbb574"
import script from "./EmployeePayroll.vue?vue&type=script&lang=js"
export * from "./EmployeePayroll.vue?vue&type=script&lang=js"
import style0 from "./EmployeePayroll.vue?vue&type=style&index=0&id=e2fbb574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports